import { render, staticRenderFns } from "./LocationLanguages.vue?vue&type=template&id=091ad4c4"
import script from "./LocationLanguages.vue?vue&type=script&lang=js"
export * from "./LocationLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports